module.exports = __webpack_public_path__ + "img/fig_rosalee_pl.baa99276.png";